import axios from 'axios';

export const moduleMyFx = {
	state() {
		return {
			myFx: null,
			bankAccountList: null,
			//Loader
			bankAccountListLoader: false,
		};
	},
	mutations: {
		setMyFx(state, data) {
			state.myFx = data;
		},
		setBankAcccountList(state, data) {
			state.bankAccountList = data;
		},

		setBirthCountry(state, data) {
			state.myFx.birthCountry = data;
		},
		setDocumentTypeId(state, data) {
			state.myFx.documentTypeId = data;
		},
		setDocumentNumber(state, data) {
			state.myFx.documentNumber = data;
		},
		setDocumentValidityDate(state, data) {
			state.myFx.documentValidityDate = data;
		},
		setBirthPlace(state, data) {
			state.myFx.birthPlace = data;
		},
		setMobilePhone(state, data) {
			state.myFx.mobilePhone = data;
		},
		setEmail(state, data) {
			state.myFx.email = data;
		},
		setIsResident(state, data) {
			state.myFx.isResident = data;
		},
		setMotherName(state, data) {
			state.myFx.motherName = data;
		},
		setFatherName(state, data) {
			state.myFx.fatherName = data;
		},
		setTaxOfficeId(state, data) {
			state.myFx.taxOfficeId = data;
		},
		setTaxCityId(state, data) {
			state.myFx.taxCityId = data;
		},
		setisOtherCountryTaxPayee(state, data) {
			state.myFx.isOtherCountryTaxPayee = data;
			if (!data) state.myFx.countryOfTaxPayee = [];
		},

		setMainAddressStreet(state, data) {
			state.myFx.mainAddress.street = data;
		},
		setMainAddressBuildingNo(state, data) {
			state.myFx.mainAddress.buildingNumber = data;
		},
		setMainAddressFlatNo(state, data) {
			state.myFx.mainAddress.flatNumber = data;
		},
		setMainAddressPostalCode(state, data) {
			state.myFx.mainAddress.postalCode = data;
		},
		setMainAddressCity(state, data) {
			state.myFx.mainAddress.city = data;
		},
		setMainAddressProvinceId(state, data) {
			state.myFx.mainAddress.provinceId = data;
		},
		setMainAddressCountryId(state, data) {
			state.myFx.mainAddress.countryId = data;
		},
		setMainAddressCountry(state, data) {
			state.myFx.mainAddress.country = data;
		},

		setCorrespondanceAddressStreet(state, data) {
			state.myFx.correspondAddress.street = data;
		},
		setCorrespondanceAddressBuildingNo(state, data) {
			state.myFx.correspondAddress.buildingNumber = data;
		},
		setCorrespondanceAddressFlatNo(state, data) {
			state.myFx.correspondAddress.flatNumber = data;
		},
		setCorrespondanceAddressPostalCode(state, data) {
			state.myFx.correspondAddress.postalCode = data;
		},
		setCorrespondanceAddressCity(state, data) {
			state.myFx.correspondAddress.city = data;
		},
		setCorrespondanceAddressProvinceId(state, data) {
			state.myFx.correspondAddress.provinceId = data;
		},
		setCorrespondanceAddressCountryId(state, data) {
			state.myFx.correspondAddress.countryId = data;
		},
		setCorrespondanceAddressCountry(state, data) {
			state.myFx.correspondAddress.country = data;
		},

		setSameCorrespondanceAddress(state, data) {
			state.myFx.correspondenceAddressLikeMainAddress = data;
			state.myFx.correspondAddress.isNotNeccessary = data;
		},
		setDocumentNotExpiring(state, data) {
			state.myFx.documentNotExpiring = data;
		},
		/*MM TODO Kuba sprawdź po mnie te akcje co potworzyłe, n,ie mam pojęcia czy powinny być one w tym miejsciu */
		/*MM START */
		/* Nie które akcje z nazwą z '_' - w tych helparch v-input itp name jest budowany na podstawie htmlId, nie wiem czy nie wymaga poprawek, aby Id był z kropkami, a name zamieniał '.' na '_'
a nazwy akcje były bez tego - do zastanowienia */
		setCountryOfTaxPayee_Tin(state, data) {
			state.myFx.countryOfTaxPayee[data.index].tinNumber = data.value;
		},

		setCountryOfTaxPayee_Country(state, data) {
			state.myFx.countryOfTaxPayee[data.index].countryId = data.value;
			if (typeof data.text !== typeof undefined)
				state.myFx.countryOfTaxPayee[data.index].countryName =
					data.text;
		},

		setCountryOfTaxPayee_LackTin(state, data) {
			state.myFx.countryOfTaxPayee[data.index].lackTin = data.value;
			state.myFx.countryOfTaxPayee[data.index].tinNumber = '';
		},
		removeOtherCountryTaxItem(state, index) {
			state.myFx.countryOfTaxPayee.splice(index, 1);
		},
		clearOtherCountryTax(state) {
			state.myFx.countryOfTaxPayee = [];
		},
		addOtherCountryTaxRow(state) {
			if (typeof state.myFx.countryOfTaxPayee === typeof undefined)
				state.myFx.countryOfTaxPayee = [];
			if (state.myFx.countryOfTaxPayee.length < 3)
				state.myFx.countryOfTaxPayee.push({
					clientId: state.myFx.id,
					countryId: 0,
					countryName: '',
					id: 0,
					isActive: true,
					lackTin: false,
					tinNumber: '',
				});
		},
		setisUsaTaxPayeeOrHasUsaCitizenship(state, data) {
			state.myFx.isUsaTaxPayeeOrHasUsaCitizenship = data;
			if (!data) state.myFx.usaTin = '';
		},
		setUsaTin(state, data) {
			state.myFx.usaTin = data;
		},

		setAgreement_isAccepted(state, data) {
			state.myFx.agreements[data.index].isAccepted = data.value;
		},

		//Loader
		setBankAccountListLoader(state, data) {
			state.bankAccountListLoader = data;
		},

		setMotherMaidenName(state, data) {
			state.myFx.motherMaidenName = data;
		},

		/*MM STOP */
	},
	getters: {
		getMyFx: (state) => state.myFx,
		getBankAccountList: (state) => state.bankAccountList,
		//Loader
		getBankAccountListLoader: (state) => state.bankAccountListLoader,
	},
	actions: {
		fetchMyFx({ commit, dispatch }) {
			dispatch('newLogoutTime');
			commit('setMyfxViewLoader', true);

			axios
				.get('Client/View')
				.then((response) => {
					commit('setMyFx', response.data);
					if (response.data && response.data.documentValidityDate) {
						let toFormat = response.data.documentValidityDate;
						toFormat = toFormat
							.replace(/-/g, '-')
							.replace(/T.+/, '');
						commit('setDocumentValidityDate', toFormat);
					}

					return response;
				})
				.catch(() => {})
				.finally(() => {
					commit('setMyfxViewLoader', false);
				});
		},
		fetchBankAccountList({ commit, dispatch }) {
			dispatch('newLogoutTime');
			commit('setBankAccountListLoader', true);
			axios
				.get('Client/BankAccountsList')
				.then((response) => {
					commit('setBankAcccountList', response.data.records);
				})
				.catch(() => {})
				.finally(() => {
					commit('setBankAccountListLoader', false);
				});
		},
		postMyFx({ state, commit, dispatch }) {
			dispatch('newLogoutTime');
			const emailIsCorrect = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			const phoneIsCorrect = new RegExp('^\\d+$');

			let validationError = null;
			let todayDate = new Date();
			if (
				(!state.myFx.documentValidityDate ||
					new Date(state.myFx.documentValidityDate).getTime() <
						new Date(
							todayDate.toISOString().split('T')[0]
						).getTime()) &&
				!state.myFx.documentNotExpiring
			) {
				validationError = {
					validation: 'Błędna data ważności dokumentu',
				};
			} else if (!emailIsCorrect.test(state.myFx.email)) {
				validationError = {
					validation: 'Błędny adres email',
				};
			} else if (
				!(
					phoneIsCorrect.test(state.myFx.mobilePhone) &&
					state.myFx.mobilePhone.length >= 9 &&
					state.myFx.mobilePhone.length <= 13
				)
			) {
				validationError = {
					validation:
						'Numeru telefonu powinien składać się z samych cyfr a jego długość powinna być od 9 do 13 znaków',
				};
			}

			// Jeżeli kraj pochodzenia inny niż Polska to musi byc wybrany jakis inny kraj podatkowy
			const isUsaTaxes = !state.myFx.isUsaTaxPayeeOrHasUsaCitizenship
				? true
				: state.myFx.usaTin != ''
				? false
				: true;

			const isOtherCountryTaxes = !state.myFx.isOtherCountryTaxPayee
				? true
				: state.myFx.countryOfTaxPayee.length === 0;

			if (state.myFx.mainAddress.country?.toLowerCase() !== 'polska') {
				if (isUsaTaxes && isOtherCountryTaxes) {
					validationError = {
						validation:
							'Wybrałeś adres zamieszkania inny niż Polska. Dodaj kraj rezydencji podatkowej, aby zapisać zmianę danych',
					};
					return new Promise((resolve, reject) => {
						reject(validationError);
					});
				}
			}

			if (validationError) {
				return new Promise((resolve, reject) => {
					reject(validationError);
				});
			} else {
				return new Promise((resolve, reject) => {
					axios.post('Client/PersonalEdit', state.myFx).then(
						() => {
							resolve(true);
							window.scroll({
								top: 0,
								left: 0,
								behavior: 'smooth',
							});
							commit('setMyfxSave', false);
						},
						(response) => {
							reject(response);
							commit('setMyfxSave', false);
						}
					);
				});
			}
		},
	},
};
